export default __webpack_public_path__ + "static/delivery-presentation_by-c3e7c6ae80d8b6eb6d81e69cfb02977c.png";